import type { IncomingHttpHeaders } from 'http';

export const CHEWY_USER_AGENT_HEADER = 'user-agent';

const nmaUA = /chewy-android|chewy-ios/gi;

type UserAgentHeaders = IncomingHttpHeaders | Pick<Headers, 'get'>;

const hasGetMethod = (headers: UserAgentHeaders): headers is Pick<Headers, 'get'> =>
  typeof headers.get === 'function';

export const getHeaderUserAgent = (headers: UserAgentHeaders | null): string => {
  if (!headers) return 'none';

  const userAgent = hasGetMethod(headers)
    ? headers.get(CHEWY_USER_AGENT_HEADER)
    : headers[CHEWY_USER_AGENT_HEADER];

  return userAgent?.toString() ?? 'none';
};

export const isChewyMobileApp = (headers: UserAgentHeaders | null): boolean => {
  if (!headers) return false;
  const userAgent = getHeaderUserAgent(headers);
  return userAgent.match(nmaUA) !== null;
};

/**
 * Returns the version of the chewy mobile app from the user-agent header.
 * The user-agent header string is in the format of "chewy-android/1.0.0" or "chewy-ios/1.0.0".
 */
export const getChewyMobileAppVersion = (userAgent: string): string => {
  if (!userAgent) return '';
  // Match "chewy-android/x.y.z" or "chewy-ios/x.y.z" and extract the version part
  const versionMatch = userAgent.match(/chewy-(android|ios)\/(\d+\.\d+\.\d+)/i);
  if (!versionMatch || versionMatch.length < 3) return '';
  return versionMatch[2];
};

export const isAndroidChewyMobileApp = (userAgent: string): boolean => {
  return userAgent.match(/chewy-android/i) !== null;
};

export const isIOSChewyMobileApp = (userAgent: string): boolean => {
  return userAgent.match(/chewy-ios/i) !== null;
};
